module.exports = __webpack_public_path__ + "84750efdbf9a20c942ac6c3806ebea7e.glb";